import { type ReactNode } from 'react';
import { cn, Stack } from '@prenuvo/halo-web';

export interface FullPageLayoutProps {
  children: ReactNode;
  className?: string;
}

export function FullPageLayout({ children, className }: FullPageLayoutProps) {
  return (
    <Stack
      alignment="center"
      className={cn('min-h-screen', className)}
      justification="center"
      variant="vertical"
    >
      {children}
    </Stack>
  );
}
